enum MarginType {
  NEVER = "never",
  VARIABLE = "variable",
}

export { MarginType };
